export default "__VITE_ASSET__B7aj6DYd__"